import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import LoadingPage from "../../../Components/layouts/loading";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { BsCalendar2XFill } from "react-icons/bs";
import { FcCalendar } from "react-icons/fc";

const getLeavesTaken = (obj) => {
  if (obj.leaveType === "half day") {
    return 0.5;
  }
  if (obj.leaveType === "full day") {
    return 1;
  } else {
    const start = new Date(obj.leaveStartDate);
    const end = new Date(obj.leaveEndDate);
    return (end - start) / (1000 * 60 * 60 * 24) + 1;
  }
};
const workHolidays = [
  { date: "2024-08-15", holidayType: "full day" },
  { date: "2024-09-07", holidayType: "full day" },
  { date: "2024-10-02", holidayType: "full day" },
  { date: "2024-10-12", holidayType: "full day" },
  { date: "2024-11-01", holidayType: "full day" },
  { date: "2024-11-02", holidayType: "full day" },
  { date: "2024-11-03", holidayType: "full day" },
  { date: "2024-12-25", holidayType: "full day" }, /// 2024 end
  { date: "2025-01-26", holidayType: "full day" },
  { date: "2025-03-14", holidayType: "full day" },
  { date: "2025-03-30", holidayType: "full day" },
  { date: "2025-05-01", holidayType: "full day" },
  { date: "2025-05-14", holidayType: "half day" },
  { date: "2025-08-15", holidayType: "full day" },
  { date: "2025-08-27", holidayType: "full day" },
  { date: "2025-10-02", holidayType: "full day" },
  { date: "2025-10-21", holidayType: "full day" },
  { date: "2025-10-22", holidayType: "full day" },
  { date: "2025-10-23", holidayType: "full day" },
  { date: "2025-12-25", holidayType: "half day" }, // 2025 end
  { date: "2026-01-26", holidayType: "full day" },
  { date: "2026-02-19", holidayType: "full day" },
  { date: "2026-03-03", holidayType: "full day" },
  { date: "2026-03-19", holidayType: "full day" },
  { date: "2026-05-01", holidayType: "full day" },
  { date: "2026-08-15", holidayType: "full day" },
  { date: "2026-09-14", holidayType: "full day" },
  { date: "2026-10-20", holidayType: "full day" },
  { date: "2026-11-08", holidayType: "full day" },
  { date: "2026-11-11", holidayType: "full day" },
  { date: "2026-12-25", holidayType: "full day" }, // 2026 end
];

const returnCounts = (leave) => {
  let sickLeaves = 0;
  let casualLeaves = 0;
  let approvedLeaves = 0;
  let pendingLeaves = 0;
  let rejectedLeaves = 0;

  const { leavesDetails, ...data } = leave;

  // Create quick holiday lookup
  const holidayMap = new Map(
    workHolidays.map((holiday) => [holiday.date, holiday.holidayType])
  );

  for (const l of leavesDetails) {
    let leaveDays = 0;

    // Half-day leave
    if (l.leaveType === "half day") {
      leaveDays = 0.5;
    }

    // Full-day leave
    else if (l.leaveType === "full day") {
      leaveDays = 1;
    }

    // Multiple-day leave
    else {
      const startDate = new Date(l.leaveStartDate);
      const endDate = new Date(l.leaveEndDate);

      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      let currentDate = new Date(startDate);

      while (currentDate <= endDate) {
        const day = currentDate.getDay();

        // YYYY-MM-DD
        const dateString = [
          currentDate.getFullYear(),
          String(currentDate.getMonth() + 1).padStart(2, "0"),
          String(currentDate.getDate()).padStart(2, "0"),
        ].join("-");

        const holiday = holidayMap.get(dateString);

        // Sunday → do not count
        if (day === 0) {
          currentDate.setDate(currentDate.getDate() + 1);
          continue;
        }

        // Full-day holiday → do not count
        if (holiday?.holidayType === "full day") {
          currentDate.setDate(currentDate.getDate() + 1);
          continue;
        }

        // Half-day holiday → count 0.5
        if (holiday?.holidayType === "half day") {
          leaveDays += 0.5;
        } else {
          // Normal working day
          leaveDays += 1;
        }

        currentDate.setDate(currentDate.getDate() + 1);
      }
    }

    // Leave type
    if (l.leaveReasonType === "casual") {
      casualLeaves += leaveDays;
    } else {
      sickLeaves += leaveDays;
    }

    // Leave status
    if (l.leaveStatus === "approved") {
      approvedLeaves += leaveDays;
    } else if (l.leaveStatus === "pending") {
      pendingLeaves += leaveDays;
    } else if (l.leaveStatus === "rejected") {
      rejectedLeaves += leaveDays;
    }
  }

  return {
    ...data,

    sickLeaves: sickLeaves.toFixed(1),
    casualLeaves: casualLeaves.toFixed(1),

    approvedLeaves: approvedLeaves.toFixed(1),
    pendingLeaves: pendingLeaves.toFixed(1),
    rejectedLeaves: rejectedLeaves.toFixed(1),

    totalLeaves: (approvedLeaves + pendingLeaves + rejectedLeaves).toFixed(1),
  };
};

const ViewLeaves = () => {
  const user = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [leaveCount, setLeaveCount] = useState({ paid: 0, unpaid: 0 });
  const navigate = useNavigate();
  let { id } = useParams();

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/leave/getleavesById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          const fetchedData = { ...res.data, ...returnCounts(res.data) };
          let leavesDetails = fetchedData?.leavesDetails;
          setData({ ...fetchedData, leavesDetails });
        } else {
          Toast("error", "Error while getting leave details!");
        }
        setLoading(false);
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }

  let totalLeavenew = (sick, casual) => {
    let totalLeave = sick + casual;
    return totalLeave;
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="container-xxl">
              <div className="row align-items-center">
                <div className="col-md-8">
                  <h2 className="page-title mb-1">
                    <FcCalendar className="fs-2  me-1" /> View Leave
                  </h2>
                  <h4 className="text-muted">
                    {/* <StepRoutes /> */} Leaves status & updates
                  </h4>
                </div>
                <div className="col-md-4">
                  <div className="btn-list justify-content-end">
                    <a href={"/employee-leave-management"}>
                      <button className="btn btn-primary">
                        <BsCalendar2XFill className="me-2 fs-2" /> VIEW ALL
                        LEAVES
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card">
                {data && (
                  <div class="table-responsive">
                    <table class="table table-vcenter card-table table-striped">
                      <thead>
                        <tr>
                          <th>Specs.</th>
                          <th>Details</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="text-secondary">Account Name</td>
                          <td>{(data?.employeeName || "N/A").toUpperCase()}</td>
                        </tr>
                        <tr>
                          <td class="text-secondary">Employee Id</td>
                          <td>{(data?.userId || "N/A").toUpperCase()}</td>
                        </tr>
                        <tr>
                          <td class="text-secondary">Total</td>
                          <td>{data.totalLeaves ?? 0}</td>
                        </tr>
                        <tr>
                          <td class="text-secondary">Sick</td>
                          <td>{leaveCount?.sickLeaves ?? 0} </td>
                        </tr>
                        <tr>
                          <td class="text-secondary">Casual</td>
                          <td>{leaveCount?.casualLeaves ?? 0} </td>
                        </tr>
                        <tr>
                          <td class="text-secondary">Pending</td>
                          <td>{data?.pendingLeaves ?? 0}</td>
                        </tr>
                        <tr>
                          <td class="text-secondary">Rejected</td>
                          <td>{data?.rejectedLeaves ?? 0}</td>
                        </tr>
                        <tr>
                          <td class="text-secondary">Approved</td>
                          <td>{data?.approvedLeaves ?? 0}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                <div className="table-responsive">
                  {data && (
                    <table className="table table-vcenter">
                      <thead>
                        <tr>
                          <th>Leave / Reason Type</th>
                          <th>Start / End Date</th>
                          <th>Description</th>
                          <th>Leave Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.leavesDetails?.map((task, index) => (
                          <tr key={index}>
                            <td>
                              <span>
                                {task.leaveType?.toUpperCase() || "N/A"}
                              </span>
                              <br />
                              <span>
                                {task.leaveReasonType?.toUpperCase() || "N/A"}
                              </span>
                            </td>
                            <td>
                              <span>
                                {task.leaveDate || task.leaveStartDate || "N/A"}
                              </span>
                              <br />
                              <span>
                                {task.leaveEndDate || task.leaveDate || "N/A"}
                              </span>
                            </td>
                            <td style={{ maxWidth: "250px" }}>
                              {task.leaveReason || "N/A"}
                            </td>
                            <td>
                              <span
                                className={`badge ${
                                  task.leaveStatus === "approved"
                                    ? "bg-green"
                                    : task.leaveStatus === "pending"
                                    ? "bg-blue"
                                    : task.leaveStatus === "rejected"
                                    ? "bg-red"
                                    : task.leaveStatus === "revoked"
                                    ? "bg-yellow"
                                    : "bg-blue"
                                }`}
                                style={{ color: "white" }}
                              >
                                {task.leaveStatus?.toUpperCase() || "N/A"}
                              </span>
                            </td>
                            <td>
                              {user.Role !==
                                process.env.REACT_APP_ROLE_CLIENT &&
                                user.Role !==
                                  process.env.REACT_APP_ROLE_D_CLIENT && (
                                  <button
                                    onClick={() => {
                                      navigate(
                                        `/employee-leave-management/edit/${id}/${index}`
                                      );
                                    }}
                                    className={`btn mx-1 mt-2 btn-sm btn-primary`}
                                  >
                                    EDIT LEAVE
                                  </button>
                                )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
                <div className="card-footer">
                  <div className="btn-list justify-content-end">
                    <SimpleButton buttonText="CLOSE" type="secondary" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewLeaves;
